import { useState, useEffect } from "react";
import * as FeatherIcon from 'react-feather';

// ----------------------------
// ProductLines Component
// ----------------------------
const ProductLines = ({ onNext, onPrev, updateData, data }) => {
    const [product, setProduct] = useState(data.product || "");
    const [details, setDetails] = useState(data.productDetails || "");
  
    useEffect(() => {
      updateData({ product, productDetails: details });
    }, [product, details]);
  
    return (
      <div className="wizard_two">
        <h5 className="custom_lable">Select Product/Offering to Compare</h5>
        <select className="form-select mb-4 custom_input_text" value={product} onChange={(e) => setProduct(e.target.value)}>
          <option value="">Select</option>
          <option value="Offering A">Offering A</option>
          <option value="Offering B">Offering B</option>
        </select>
  
        <h5 className="custom_lable">Specific Products to Include</h5>
        <textarea
          className="form-control custom_input_textarea"
          placeholder="List specific product, features, or service to include in the benchmark"
          rows={4}
          value={details}
          onChange={(e) => setDetails(e.target.value)}
        ></textarea>
  
        <div className="mt-4">
          <button className="btn btn-secondary me-2 previous_btn_wz" onClick={onPrev}><FeatherIcon.ChevronLeft className='prev_feather'/> Previous</button>
          <button className="btn btn-primary next_btn_wz" onClick={onNext}>Next <FeatherIcon.ChevronRight className='next_feather'/></button>
        </div>
      </div>
    );
  };

  export default ProductLines;